import { useContext } from "react";
import { Home } from "./sample/Home";
import { TeamsFxContext } from "./Context";
import React from "react";
import { app, pages, authentication } from "@microsoft/teams-js";
import { ApiService } from "../api/ProjectInfoService";

export default function Tab() {
  app
    .initialize()
    .then(() => {
      if (app.isInitialized()) {
          // Set the app context
          app.getContext().then((context: any) => {
          authentication
            .getAuthToken({})
            .then(async (ssoToken: any) => {
              await ApiService.setApiToken(ssoToken);
            })
            .catch((error: any) => {
              console.error(error);
            });
          if (context.FrameContext === "settings") {
            pages.config.setValidityState(true);
            pages.config.registerOnSaveHandler((saveEvent: any) => {
              console.log("Teams Initialized");
              const configPromise = pages.config.setConfig({
                contentUrl: process.env.TAB_ENDPOINT + "/index.html#/tab",
                suggestedDisplayName: "VLHORA Project info",
              });
              configPromise
                .then((config: any) => {
                  console.log("Config set");
                  saveEvent.notifySuccess();
                })
                .catch((error: any) => {
                  console.error(error);
                  saveEvent.notifyFailure();
                });
            });
          }
          });
        }
    })
    .catch((error : any) => {
      console.error(error);
    });

  const { themeString } = useContext(TeamsFxContext);
  return (
    <div
      className={
        themeString === "default"
          ? "light"
          : themeString === "dark"
          ? "dark"
          : "contrast"
      }
    >
      <Home />
    </div>
  );
}
